<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-button size="small" type="primary" :class="[theme]" @click="handleAdd" v-if="isAdmin">添加来源</el-button>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe v-loading="loading">
				<el-table-column prop="sourceName" label="来源名称" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="createdAt" label="创建时间" align="center" width="160"></el-table-column>
				<el-table-column label="操作" width="190" align="center">
					<template #default="scope">
						<el-button size="small" type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="small" type="text" icon="el-icon-delete" style="color: #f56c6c;"
							@click="handleDelete(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :title="title" v-model="addVisible" width="520px" @close="closeDialog">
			<el-form label-width="100px" :model="addForm" ref="editForm">
				<el-form-item label="来源名称" prop="sourceName">
					<el-input size="small" v-model="addForm.sourceName" placeholder="请输入来源名称"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input size="small" type="textarea" v-model="addForm.remark" placeholder="请输入备注"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="title == '添加'"
						@click="submitAdd">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="title == '修改'"
						@click="submitUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getDijiaNumberPoolSourceList,
		addDijiaNumberPoolSource,
		updateDijiaNumberPoolSource,
		deleteDijiaNumberPoolSource
	} from '../api/dijia.js';
	export default {
		name: 'DijiaNumberPoolSource',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {},
				title: '添加',
				tableData: [],
				addForm: {
					sourceName: '',
					remark: ''
				},
				addVisible: false,
				isAdmin: false,
				isCompany: false,
				isAgent: false
			};
		},

		created() {
			let role = localStorage.getItem('ms_role');
			if (role === 'company') {
				this.isCompany = true;
			}
			if (role === 'admin') {
				this.isAdmin = true;
			}
			if (role === 'agent') {
				this.isAgent = true;
			}
			this.getData();
		},
		methods: {
			getData() {
				this.loading = true;
				getDijiaNumberPoolSourceList().then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleAdd() {
				this.title = '添加';
				this.addVisible = true;
				this.addForm = {
					sourceName: '',
					remark: ''
				};
			},
			handleEdit(row) {
				this.title = '修改';
				this.addVisible = true;
				this.addForm = {
					id: row.id,
					sourceName: row.sourceName,
					remark: row.remark
				};
			},
			submitAdd() {
				if (!this.addForm.sourceName) {
					this.$message.error('来源名称不能为空');
					return;
				}
				let data = {
					sourceName: this.addForm.sourceName,
					remark: this.addForm.remark
				};
				addDijiaNumberPoolSource(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('添加成功');
						this.getData();
					} else {
						this.$message.error(res.message);
					}
					this.addVisible = false;
				});
			},
			submitUpload() {
				let data = {
					id: this.addForm.id,
					sourceName: this.addForm.sourceName,
					remark: this.addForm.remark
				};
				updateDijiaNumberPoolSource(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('修改成功');
						this.getData();
					} else {
						this.$message.error(res.message);
					}
					this.addVisible = false;
				});
			},
			closeDialog() {
				this.addVisible = false;
			},
			handleDelete(row) {
				this.$confirm('确定要删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						deleteDijiaNumberPoolSource(row.id).then(res => {
							if (res?.code === 200) {
								this.$message.success('删除成功');
								this.getData();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}
</style>
